import { BaseForm } from '~/base/BaseForm';

export enum SurveyResultCommentFormField {
  comments = 'comments',
}

export class SurveyResultCommentForm extends BaseForm {
  comments: Record<number, string> = {};

  constructor(props?: unknown) {
    super(props);
    this.load(props);
  }
}
